export default __webpack_public_path__ + "static/media/bedIcon.eefa75b1.svg";